import { FC } from 'react';
import { useDownloadExpertReport } from '@/entities/expert-report';
import type { FileDownloadFormat } from '@/shared/lib';
import { DownloadFormatButton } from '@/shared/ui';

type Props = {
  conversationId: number;
  expertReportId: number;
};

export const DownloadExpertReportButton: FC<Props> = ({ conversationId, expertReportId }) => {
  const { mutate: download, isPending } = useDownloadExpertReport();

  const handleDownload = (format: FileDownloadFormat) => {
    download({ conversationId, expertReportId, format });
  };

  return <DownloadFormatButton onDownload={handleDownload} isPending={isPending} />;
};
